"use client"
import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { FilterMatchMode } from 'primereact/api';

import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Toast } from 'primereact/toast';
//import { InputTextarea } from 'primereact/inputtextarea';
//import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';
import { ColorPicker } from 'primereact/colorpicker';
import { Panel } from 'primereact/panel';
import { Card } from 'primereact/card';

import { Rating } from 'primereact/rating';
//import { FileUpload } from 'primereact/fileupload';

import { MultiSelect } from 'primereact/multiselect';

import { Toolbar } from 'primereact/toolbar';
import { Skeleton } from 'primereact/skeleton';
import { SelectButton } from 'primereact/selectbutton';
import { OverlayPanel } from 'primereact/overlaypanel';
import Link from 'next/link';


import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import { PlantillaService } from '../../service/PlantillaService';

import AuthStorage from '../../storage/AuthStorage.js';

import Formulario from './Formulario.js';
import FormularioCalificacionRA from './FormularioCalificacionRA';

import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
//import { Switch } from 'react-router-dom';
//import { render } from 'preact/compat';
//import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import lodash from "lodash";
import { Exception } from 'sass';


const DiseñadorFormulario = React.forwardRef((props, ref) => {

    const _ = lodash;
    const dtSegmento = useRef(null);
    const formRef = useRef(null);

    const formRefSegmento = useRef(null);
    const formRefPregunta = useRef(null);

    const formFacturaRef = useRef(null);

    const formFacturaRefSegmento = useRef(null);
    const formFacturaRefPregunta = useRef(null);

    const overlayPanelRef = useRef(null);


    const codModulo = "DATATABLE_GENERICA";

    const plantillaService = new PlantillaService();
    const genericaSistemaService = new GenericaSistemaService();

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const { userName, idEmpresa, idioma } = userDetails;

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);

    const [canEditRow, setCanEditRow] = useState(false);
    const [canEditRowSegmento, setCanEditRowSegmento] = useState(false);
    const [canEditRowPregunta, setCanEditRowPregunta] = useState(false);

    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const prevSelectedTipoGenericaRef = useRef(undefined);

    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);
    const [selectedTipoGenericaSegmento, setSelectedTipoGenericaSegmento] = useState(undefined);
    const [selectedTipoGenericaPregunta, setSelectedTipoGenericaPregunta] = useState(undefined);

    const [selectedTipoGenericaFormulario, setSelectedTipoGenericaFormulario] = useState(undefined);
    const [selectedTipoGenericaFormularioSegmento, setSelectedTipoGenericaFormularioSegmento] = useState(undefined);
    const [selectedTipoGenericaFormularioPregunta, setSelectedTipoGenericaFormularioPregunta] = useState(undefined);

    const [selectedTipoGenericaFormularioFactura, setSelectedTipoGenericaFormularioFactura] = useState(undefined);
    const [selectedTipoGenericaFormularioFacturaSegmento, setSelectedTipoGenericaFormularioFacturaSegmento] = useState(undefined);
    const [selectedTipoGenericaFormularioFacturaPregunta, setSelectedTipoGenericaFormularioFacturaPregunta] = useState(undefined);

    const [selectedGenericasSistemaSegmento, setSelectedGenericasSistemaSegmento] = useState(null);
    const [selectedGenericasSistemaPregunta, setSelectedGenericasSistemaPregunta] = useState(null);

    const [genericaSistemaDialogFormulario, setGenericaSistemaDialogFormulario] = useState(false);
    const [genericaSistemaDialogFormularioSegmento, setGenericaSistemaDialogFormularioSegmento] = useState(false);
    const [genericaSistemaDialogFormularioPregunta, setGenericaSistemaDialogFormularioPregunta] = useState(false);

    const [genericaSistemaDialogFormularioFactura, setGenericaSistemaDialogFormularioFactura] = useState(false);
    const [genericaSistemaDialogFormularioFacturaSegmento, setGenericaSistemaDialogFormularioFacturaSegmento] = useState(false);
    const [genericaSistemaDialogFormularioFacturaPregunta, setGenericaSistemaDialogFormularioFacturaPregunta] = useState(false);

    const [deletegenericaSistemaDialogFormulario, setDeletegenericaSistemaDialogFormulario] = useState(false);
    const [deletegenericasSistemaDialog, setdeletegenericasSistemaDialog] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const [dialogTextVisible, setDialogTextVisible] = useState(false);
    const [dialogText, setDialogText] = useState("");

    const __GENERICA_PREGUNTA = "FMT_VSTA_DISEÑO_FORMATO_PREGUNTA";
    const __GENERICA_SEGMENTO = "FMT_VSTA_DISEÑO_FORMATO_SEGMENTO";
    const __GENERICA_TIPO_DATO = "FMT_VSTA_DISEÑO_FORMATO_TIPO_PREGUNTA";

    const [segmentos, setSegmentos] = useState([]);
    const [preguntas, setPreguntas] = useState([]);
    const [tipoPreguntas, setTipoPreguntas] = useState([]);

    //const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const [expandedRowsPregunta, setExpandedRowsPregunta] = useState(null);
    const [expandedRowsSegmento, setExpandedRowsSegmento] = useState(null);


    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);
    const [metadataGenericaSistemaSegmento, setMetadataGenericaSistemaSegmento] = useState([]);
    const [metadataGenericaSistemaPregunta, setMetadataGenericaSistemaPregunta] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);
    const [metadataGenericaSistemaTgOperacionesSegmento, setMetadataGenericaSistemaTgOperacionesSegmento] = useState([]);
    const [metadataGenericaSistemaTgOperacionesPregunta, setMetadataGenericaSistemaTgOperacionesPregunta] = useState([]);

    const [metadataGenericaSegmento, setMetadataGenericaSegmento] = useState([]);
    const [metadataGenericaPregunta, setMetadataGenericaPregunta] = useState([]);



    const [metadataGenericaFormulario, setMetadataGenericaFormulario] = useState([]);
    const [metadataGenericaFormularioSegmento, setMetadataGenericaFormularioSegmento] = useState([]);
    const [metadataGenericaFormularioPregunta, setMetadataGenericaFormularioPregunta] = useState([]);

    const [metadataGenericaFormularioFactura, setMetadataGenericaFormularioFactura] = useState([]);
    const [metadataGenericaFormularioFacturaSegmento, setMetadataGenericaFormularioFacturaSegmento] = useState([]);
    const [metadataGenericaFormularioFacturaPregunta, setMetadataGenericaFormularioFacturaPregunta] = useState([]);

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [genericaFormulario, setGenericaFormulario] = useState(emptyGenericaSistemaInit);

    const [genericaFormularioSegmento, setGenericaFormularioSegmento] = useState(emptyGenericaSistemaInit);
    const [genericaFormularioPregunta, setGenericaFormularioPregunta] = useState(emptyGenericaSistemaInit);

    const [genericaFormularioFactura, setGenericaFormularioFactura] = useState(emptyGenericaSistemaInit);
    const [genericaFormularioFacturaSegmento, setGenericaFormularioFacturaSegmento] = useState(emptyGenericaSistemaInit);
    const [genericaFormularioFacturaPregunta, setGenericaFormularioFacturaPregunta] = useState(emptyGenericaSistemaInit);

    const [metadataGenericaSistemaRef, setMetadataGenericaSistemaRef] = useState([]);
    const [metadataGenericaSistemaRefSegmento, setMetadataGenericaSistemaRefSegmento] = useState([]);
    const [metadataGenericaSistemaRefPregunta, setMetadataGenericaSistemaRefPregunta] = useState([]);

    //const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedColumnsSegmentos, setSelectedColumnsSegmentos] = useState([]);
    const [selectedColumnsPreguntas, setSelectedColumnsPreguntas] = useState([]);

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);
    const [emptyGenericaSistemaSegmento, setEmptyGenericaSistemaSegmento] = useState(emptyGenericaSistemaInit);
    const [emptyGenericaSistemaPregunta, setEmptyGenericaSistemaPregunta] = useState(emptyGenericaSistemaInit);


    //const [selectAll, setSelectAll] = useState(false);

    const [genericasSistema, setGenericasSistema] = useState([{ ctiTexto: "" }]);

    const lazyParamInit = {
        first: 0,
        rows: 1000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const lazyParamInitSegmento = {
        first: 0,
        rows: 1000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const lazyParamInitPregunta = {
        first: 0,
        rows: 1000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };


    const [lazyParams, setLazyParams] = useState(Object.assign({}, lazyParamInit));
    const [lazyParamsSegmento, setLazyParamsSegmento] = useState(Object.assign({}, lazyParamInitSegmento));
    const [lazyParamsPregunta, setLazyParamsPregunta] = useState(Object.assign({}, lazyParamInitPregunta));

    const [lazyParamsInitSelected, setLazyParamsInitSelected] = useState(Object.assign({}, lazyParamInit));
    const [lazyParamsInitSelectedSegmento, setLazyParamsInitSelectedSegmento] = useState(Object.assign({}, lazyParamInitSegmento));
    const [lazyParamsInitSelectedPregunta, setLazyParamsInitSelectedPregunta] = useState(Object.assign({}, lazyParamInitPregunta));

    if (props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) {
        setSelectedTipoGenerica(props.selectedTipoGenerica);
    }
    else if (props.selectedTipoGenerica !== undefined) {
        if ((props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg)) {
            setSelectedTipoGenerica(props.selectedTipoGenerica);
        }
        else if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, filtroUts: props.selectedTipoGenerica.filtroUts };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }

    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }


    useEffect(() => {
        LoadEtiquetas();
    }, []);

    const LoadEtiquetas = async => {

        plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, "DiseñadorFormulario").then(data => {
            setEtiquetasModulo(data);
        });

    }

    useEffect(() => {

        let prevselectedTipoGenerica = { ...selectedTipoGenerica }

        if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined) {
            LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            prevselectedTipoGenerica["intentoMetadata"] = 1;
        }
        else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined) {

            if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 1;
            }
            else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
            }
            else if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && optionsSelectButton === undefined) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            }
            else {
                setLazyParams({ ...lazyParams });
            }

        }

        prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

    }, [selectedTipoGenerica])


    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "" && (selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

            genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                let newSelectedTipoGenerica = data.data;

                if (selectedTipoGenerica.filtroUts) {
                    newSelectedTipoGenerica.filtroUts = selectedTipoGenerica.filtroUts;
                    newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                }
                if (selectedTipoGenerica.version) {
                    newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                }

                setSelectedTipoGenerica(newSelectedTipoGenerica);

            });
        }

        //if ( selectedTipoGenerica.operaciones!==undefined && metadataGenericaSistema.operaciones.length>0){
        if (metadataGenericaSistema.length === 0) {

            await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {

                let columnaIdentificadorOculta = "tg";
                let prefijo = '000000';
                let TamSufijo = 4;
                data = data.sort(function (a, b) {
                    let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                    let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                    return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                });

                data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                let _metadataGenericaSistemaTgOperaciones = data.map(x => x);

                setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                //let metadataSegmento = data.filter(col => col.tg === __GENERICA_SEGMENTO);
                //let metadataPregunta = data.filter(col => col.tg === __GENERICA_PREGUNTA);

                //console.log("metadataSegmento, ", metadataSegmento);
                //setMetadataGenericaSegmento(metadataSegmento);
                //setMetadataGenericaPregunta(metadataPregunta);

                data = data.filter(col => col.tg === _tg);

                let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                let dataForm = metadataImprimible;
                let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                let newSelectedColumns = metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)

                //let newSelectedColumnsSegmentos = metadataSegmento.filter(col => col.campo !== columnaIdentificadorOculta)
                //let newSelectedColumnsPreguntas = metadataPregunta.filter(col => col.campo !== columnaIdentificadorOculta)

                if (dataRef.length > 0) {

                    //setSelectedColumns([]);
                    setSelectedColumnsSegmentos([]);
                    setSelectedColumnsPreguntas([]);

                    setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                    lazyParamInit.filters = createHeaderGenerica(dataForm);
                    let newLazyParamInit = Object.assign({}, lazyParamInit);

                    setMetadataGenericaSistema(data);

                    setMetadataGenericaSistemaRef(dataRef);
                    setMetadataGenericaFormulario(dataForm);
                    setMetadataGenericaFormularioFactura(dataForm);

                    setSelectedTipoGenericaFormulario(selectedTipoGenerica);
                    setSelectedTipoGenericaFormularioFactura(selectedTipoGenerica);

                    setLazyParams(newLazyParamInit);
                    setLazyParamsInitSelected(newLazyParamInit);

                    if (selectedTipoGenerica.operaciones)
                        setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));

                    setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                    setGenericaFormulario(emptyGenericaSistema);
                    setGenericaFormularioFactura(emptyGenericaSistema);


                    LoadDatosTipoPreguntas();
                    LoadDatosEstucturaSegmento();
                    LoadDatosEstucturaPregunta();

                }

            });

            if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && optionsSelectButton === undefined) {

                await genericaSistemaService.GetOptionsSelectButtonDeTg(_tg, idEmpresa, idioma, userName, selectedTipoGenerica.filtroUts).then(data => {

                    setOptionsSelectButton(data);
                });
            }
            else if (selectedTipoGenerica.tg !== "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA") {
                setOptionsSelectButton([]);
            }



        }

    }

    const LoadDatosEstucturaSegmento = async () => {

        let _tg = __GENERICA_SEGMENTO;

        genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, _tg).then(data => {

            let newselectedTipoGenericaSegmento = data.data;

            if (selectedTipoGenericaSegmento !== undefined && selectedTipoGenericaSegmento.filtroUts) {
                newselectedTipoGenericaSegmento.filtroUts = selectedTipoGenerica.filtroUts;
                newselectedTipoGenericaSegmento.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
            }
            if (selectedTipoGenericaSegmento !== undefined && selectedTipoGenericaSegmento.version) {
                newselectedTipoGenericaSegmento.version = selectedTipoGenericaSegmento.version;
            }

            setSelectedTipoGenericaSegmento(newselectedTipoGenericaSegmento);

            if (metadataGenericaSistemaSegmento.length === 0) {

                genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {

                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = data.map(x => x);

                    setMetadataGenericaSistemaTgOperacionesSegmento(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    console.log("metadataSegmento, ", data);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let newSelectedColumns = metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                    //let newSelectedColumnsSegmentos = metadataSegmento.filter(col => col.campo !== columnaIdentificadorOculta)

                    if (dataRef.length > 0) {

                        //setSelectedColumns([]);
                        //setSelectedColumnsSegmentos([]);

                        setEmptyGenericaSistemaSegmento(crearNewEmptyGenerica(dataForm, selectedTipoGenericaSegmento));

                        lazyParamInitSegmento.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInitSegmento);

                        setMetadataGenericaSistemaSegmento(data);

                        setMetadataGenericaSistemaRefSegmento(dataRef);
                        setMetadataGenericaFormularioSegmento(dataForm);
                        setMetadataGenericaFormularioFacturaSegmento(dataForm);

                        setSelectedTipoGenericaFormularioSegmento(selectedTipoGenericaSegmento);
                        setSelectedTipoGenericaFormularioFacturaSegmento(selectedTipoGenericaSegmento);

                        setLazyParamsSegmento(newLazyParamInit);
                        setLazyParamsInitSelectedSegmento(newLazyParamInit);

                        setSelectedColumnsSegmentos(newSelectedColumns);
                        setCanEditRowSegmento(newselectedTipoGenericaSegmento.operaciones === undefined ? false : newselectedTipoGenericaSegmento.operaciones.some(x => x.tg === newselectedTipoGenericaSegmento.tg && x.tipoOperacion === "EDIT_ROW"));

                        setMetadataGenericaSistemaTgOperacionesSegmento(_metadataGenericaSistemaTgOperaciones);
                        setGenericaFormularioSegmento(emptyGenericaSistemaSegmento);
                        setGenericaFormularioFacturaSegmento(emptyGenericaSistemaSegmento);

                        LoadDatosSegmentos();

                    }

                });

            }

        });

    }

    const LoadDatosEstucturaPregunta = async () => {

        let _tg = __GENERICA_PREGUNTA;

        genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, _tg).then(data => {

            let newselectedTipoGenericaPregunta = data.data;

            if (selectedTipoGenericaPregunta !== undefined && selectedTipoGenericaPregunta.filtroUts) {
                newselectedTipoGenericaPregunta.filtroUts = selectedTipoGenerica.filtroUts;
                newselectedTipoGenericaPregunta.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
            }
            if (selectedTipoGenericaPregunta !== undefined && selectedTipoGenericaPregunta.version) {
                newselectedTipoGenericaPregunta.version = selectedTipoGenericaPregunta.version;
            }

            setSelectedTipoGenericaPregunta(newselectedTipoGenericaPregunta);

            if (metadataGenericaSistemaPregunta.length === 0) {

                genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {

                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = data.map(x => x);

                    setMetadataGenericaSistemaTgOperacionesPregunta(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    console.log("metadataPregunta, ", data);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let newSelectedColumns = metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                    //let newSelectedColumnsPreguntas = metadataPregunta.filter(col => col.campo !== columnaIdentificadorOculta)

                    if (dataRef.length > 0) {

                        //setSelectedColumns([]);
                        //setSelectedColumnsPreguntas([]);

                        setEmptyGenericaSistemaPregunta(crearNewEmptyGenerica(dataForm, selectedTipoGenericaPregunta));

                        lazyParamInitPregunta.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInitPregunta);

                        setMetadataGenericaSistemaPregunta(data);

                        setMetadataGenericaSistemaRefPregunta(dataRef);
                        setMetadataGenericaFormularioPregunta(dataForm);
                        setMetadataGenericaFormularioFacturaPregunta(dataForm);

                        setSelectedTipoGenericaFormularioPregunta(selectedTipoGenericaPregunta);
                        setSelectedTipoGenericaFormularioFacturaPregunta(selectedTipoGenericaPregunta);

                        setLazyParamsPregunta(newLazyParamInit);
                        setLazyParamsInitSelectedPregunta(newLazyParamInit);

                        setSelectedColumnsPreguntas(newSelectedColumns);
                        setCanEditRowPregunta(newselectedTipoGenericaPregunta.operaciones === undefined ? false : newselectedTipoGenericaPregunta.operaciones.some(x => x.tg === newselectedTipoGenericaPregunta.tg && x.tipoOperacion === "EDIT_ROW"));

                        setMetadataGenericaSistemaTgOperacionesPregunta(_metadataGenericaSistemaTgOperaciones);
                        setGenericaFormularioPregunta(emptyGenericaSistemaPregunta);
                        setGenericaFormularioFacturaPregunta(emptyGenericaSistemaPregunta);

                        LoadDatosPreguntas();

                    }

                });

            }

        });

    }

    const LoadDatosSegmentos = async () => {

        let filtroUts = { ...selectedTipoGenerica.filtroUts };

        genericaSistemaService.getGenericasSistema(__GENERICA_SEGMENTO, { lazyEvent: JSON.stringify(lazyParamInit) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);
            console.log("segmentos, ", data.data);
            setSegmentos(data.data);

        });

    }

    const LoadDatosPreguntas = async () => {

        let filtroUts = { ...selectedTipoGenerica.filtroUts };

        genericaSistemaService.getGenericasSistema(__GENERICA_PREGUNTA, { lazyEvent: JSON.stringify(lazyParamInit) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);
            console.log("preguntas, ", data.data);
            setPreguntas(data.data);

        });

    }

    const LoadDatosTipoPreguntas = async () => {

        let filtroUts = { ...selectedTipoGenerica.filtroUts };

        genericaSistemaService.getGenericasSistema(__GENERICA_TIPO_DATO, { lazyEvent: JSON.stringify(lazyParamInit) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);
            console.log("setTipoPreguntas, ", data.data);
            setTipoPreguntas(data.data);

        });

    }

    const openNew = () => {

        console.log("crearNewEmptyGenerica");
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        //let eventTarget = event.target;
        //let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        //let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        /*let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }*/

        let idOpsGenerica = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "NEW").id;

        console.log("idOpsGenerica, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "NEW")
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }*/

            var guid = window.crypto.randomUUID();
            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.id = -1;

            if (selectedTipoGenerica.filtroUts !== undefined && !_.isEqual(selectedTipoGenerica.filtroUts, {})) {
                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotgRef] = selectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = selectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                    }
                }
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            /*
            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                console.log("Campo,", campo, genericaSistema.uts[campo], typeof genericaSistema.uts[campo]);  
            }
            */

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("datoRelacionadoVacioReportar, ", datoRelacionadoVacio);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            //console.log("genericaSistema,", genericaSistema);

            setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
            setMetadataGenericaFormulario(metadataTgOperacion);
            setGenericaFormulario(datoRelacionadoVacio);
            setGenericaSistemaDialogFormulario(true);
            setSubmitted(false);

        }
        else {

        }


    }


    const openNewPregunta = () => {

        console.log("openNewPregunta");
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        //let eventTarget = event.target;
        //let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        //let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        /*let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }*/

        let idOpsGenerica = selectedTipoGenericaPregunta.operaciones.find(x => x.tipoOperacion === "NEW").id;

        console.log("idOpsGenerica, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenericaPregunta.operaciones.length; i++) {
                tgRef = selectedTipoGenericaPregunta.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "NEW")
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }*/

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperacionesPregunta.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.id = -1;

            if (selectedTipoGenericaPregunta.filtroUts !== undefined && !_.isEqual(selectedTipoGenericaPregunta.filtroUts, {})) {
                for (let i = 0; i < selectedTipoGenericaPregunta.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenericaPregunta.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotgRef] = selectedTipoGenericaPregunta.filtroUts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = selectedTipoGenericaPregunta.filtroUts[itemOpsCampo.campotg];
                    }
                }
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            /*
            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                console.log("Campo,", campo, genericaSistema.uts[campo], typeof genericaSistema.uts[campo]);  
            }
            */

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("datoRelacionadoVacioReportar, ", datoRelacionadoVacio);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            //console.log("genericaSistema,", genericaSistema);

            setSelectedTipoGenericaFormularioPregunta(newSelectedTipoGenerica);
            setMetadataGenericaFormularioPregunta(metadataTgOperacion);
            setGenericaFormularioPregunta(datoRelacionadoVacio);
            setGenericaSistemaDialogFormularioPregunta(true);
            setSubmitted(false);

        }
        else {

        }


    }

    const deleteSelectedgenericasSistema = async (metadataRef) => {


        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        //let eventTarget = event.target;
        //let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        //let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        /*let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }*/

        let idOpsGenerica = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "REMOVE").id;

        console.log("idOpsGenerica, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "REMOVE")
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }*/

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            throw new Exception("Falta implementar pregunta");
            datoRelacionadoVacio.id = selectedGenericasSistemaSegmento.id;

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotgRef] = selectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                    throw new Exception("Falta implementar pregunta");
                    datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = selectedGenericasSistemaSegmento.uts[itemOpsCampo.campotg];
                }
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            /*
            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                console.log("Campo,", campo, genericaSistema.uts[campo], typeof genericaSistema.uts[campo]);  
            }
            */

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("datoRelacionadoVacioReportar, ", datoRelacionadoVacio);

            await genericaSistemaService.removeGenericaSistema(idEmpresa, idioma, userName, datoRelacionadoVacio).then(response => {
                throw new Exception("Falta implementar pregunta");
                let _genericasSistema = genericasSistema.filter(val => val.id !== selectedGenericasSistemaSegmento.id);
                setGenericasSistema(_genericasSistema);
                setdeletegenericasSistemaDialog(false);
                //setSelectedGenericasSistemaSegmento(null);
                //setSelectedGenericasSistemaPregunta(null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'genericasSistema Deleted', life: 3000 });

            });

        }
    }


    const hideDialog = () => {
        setSubmitted(false);
        setGenericaSistemaDialogFormulario(false);
        setGenericaSistemaDialogFormularioFactura(false);
    }

    const hideDialogPregunta = () => {
        setSubmitted(false);
        setGenericaSistemaDialogFormularioPregunta(false);
        setGenericaSistemaDialogFormularioFacturaPregunta(false);
    }

    const hidedeletegenericaSistemaDialogFormulario = () => {
        setDeletegenericaSistemaDialogFormulario(false);
    }

    const hidedeletegenericasSistemaDialog = () => {
        setdeletegenericasSistemaDialog(false);
    }

    const sendMailGenerica = async (e, rowData) => {

        //let { rowData, newValue, field, originalEvent: event } = e;

        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoading(true);

        //[field] = newValue;

        let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.tipoOperacion === "SEND_EMAIL")

        let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

        let itemOpsCampo = {};

        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
            itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
            if (itemOpsCampo.id === tgRefOps.id) {
                genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
            }
        }
        //genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

        console.log("sendemail, ", genericaSistema);

        await genericaSistemaService.sendEmail(idEmpresa, idioma, userName, genericaSistema).then(response => {

            console.log("response, ", response);

            let genericaSistemaAffect = response.genericasSistemaAffected[0];

            if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {

                if (response.mensaje === "") {

                    if (rowData.id > 0) {
                        //rowData.uts[field] = newValue;
                        rowData.uts = genericaSistemaAffect.uts;
                    }
                    else {
                        rowData.id = genericaSistemaAffect.id;
                        rowData.cti = genericaSistemaAffect.cti;
                        //rowData.uts[field] = newValue;
                        rowData.uts = genericaSistemaAffect.uts;

                        /*const index = findIndexById(rowData.id);
                        let _genericasSistema = [...genericasSistema]
 
                        _genericasSistema[index].id = response.id;
                        _genericasSistema[index].cti = response.cti;
                        if (response.campoSequenceTg!=="")
                        _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
 
                        setGenericasSistema(_genericasSistema);*/

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                    }




                    //setGenericaSistemaDialogFormulario(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {

                    if (rowData.id > 0) {
                        //rowData.uts[field] = newValue;
                        //rowData.uts  = genericaSistemaAffect.uts;
                    }
                    else {
                        rowData.id = response.id;
                        rowData.cti = response.cti;
                        if (response.campoSequenceTg !== "")
                            rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                        //rowData.uts[field] = newValue;

                        /*const index = findIndexById(rowData.id);
                        let _genericasSistema = [...genericasSistema]
 
                        _genericasSistema[index].id = response.id;
                        _genericasSistema[index].cti = response.cti;
                        if (response.campoSequenceTg!=="")
                        _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
 
                        setGenericasSistema(_genericasSistema);*/

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                    }

                }

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
            }

        });

        /*
        switch (field) {
            case 'quantity':
            case 'price':
                if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                else event.preventDefault();
                break;
        }*/

        setLoading(false);

    };


    const editGenericaSistemaFormulario = async (event, genericaSistema) => {

        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica && operaciontgRef.tipoOperacion === "EDIT")
                    break;
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            if (operaciontgRef.tgRef !== selectedTipoGenerica.tg) {

                await genericaSistemaService.getGenericaSistemaById(idEmpresa, idioma, userName, operaciontgRef.tgRef, genericaSistema.id).then(response => {

                    let datoGenTgRef = response.data;

                    let filtroUts = {};
                    let itemOpsCampo = {};
                    let ctiTextoFiltroUts = "";

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === idOpsGenerica) {
                            filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                            datoGenTgRef.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                            if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                                ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                            }

                        }
                    }

                    ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                    var guid = window.crypto.randomUUID();

                    let newSelectedTipoGenerica = {
                        tg: operaciontgRef.tgRef,
                        cti: operaciontgRef.ctitgRef,
                        ctiTexto: operaciontgRef.ctiTextotgRef,
                        orden: operaciontgRef.ordentgRef,
                        cgCampo: operaciontgRef.cgCampotgRef,
                        operaciones: undefined,
                        version: guid,
                        filtroUts: filtroUts,
                        ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                    }

                    let camposGS = Object.keys(genericaSistema.uts);
                    let camposN = Object.keys(datoGenTgRef.uts);

                    let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                    let campo = "";

                    for (let i in camposIguales) {

                        campo = camposIguales[i];
                        datoGenTgRef.uts[campo] = genericaSistema.uts[campo];
                    }


                    //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                    console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                    //console.log("metadataTgOperacion,", metadataTgOperacion);
                    console.log("datoRelacionadoVacio,", datoGenTgRef);

                    setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                    setMetadataGenericaFormulario(metadataTgOperacion);
                    setGenericaFormulario(datoGenTgRef);
                    setGenericaSistemaDialogFormulario(true);

                });

            }
            else {

                let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
                datoRelacionadoVacio.id = genericaSistema.id;
                //datoRelacionadoVacio.uts = {}

                let filtroUts = {};
                let itemOpsCampo = {};
                let ctiTextoFiltroUts = "";

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                        if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                            ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                        }

                    }
                }

                ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);
                
                var guid = window.crypto.randomUUID();

                let newSelectedTipoGenerica = {
                    tg: operaciontgRef.tgRef,
                    cti: operaciontgRef.ctitgRef,
                    ctiTexto: operaciontgRef.ctiTextotgRef,
                    orden: operaciontgRef.ordentgRef,
                    cgCampo: operaciontgRef.cgCampotgRef,
                    operaciones: undefined,
                    version: guid,
                    filtroUts: filtroUts,
                    ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                }

                //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                let camposGS = Object.keys(genericaSistema.uts);
                let camposN = Object.keys(datoRelacionadoVacio.uts);

                let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                let campo = "";

                for (let i in camposIguales) {

                    campo = camposIguales[i];
                    datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                }

                //console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                //console.log("metadataTgOperacion,", metadataTgOperacion);
                console.log("datoRelacionadoVacio,", datoRelacionadoVacio);

                setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                setMetadataGenericaFormulario(metadataTgOperacion);
                setGenericaFormulario(datoRelacionadoVacio);
                setGenericaSistemaDialogFormulario(true);

            }

        }
        else {

        }


    }



    const editGenericaSistemaFormularioFactura = (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "REPORT")
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }

                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
            }

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            console.log("genericaSistema,", genericaSistema);

            setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
            setMetadataGenericaFormularioFactura(metadataTgOperacion);
            setGenericaFormularioFactura(datoRelacionadoVacio);
            setGenericaSistemaDialogFormularioFactura(true);

        }
        else {

        }

    }

    const reportarEvidencia = (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "REPORT")
                    break;
            }


            let filtroUts = {};
            let itemOpsCampo = {};



            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }
                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            let variableRestriccionExterna = {};
            let variable = undefined;


            //console.log("metadataTgOperacion, ", metadataTgOperacion, metadataTgOperacion.filter(x=> x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_") ));

            //console.log("encontrado, ",   metadataTgOperacion.filter(x=> x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_") ));

            metadataTgOperacion.filter(x => (x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_")) || (x.restriccionFormatoMin !== null && x.restriccionFormatoMin.includes("[[EXTERNO_"))
            ).forEach(campoExterno => {

                variable = metadataGenericaSistema.find(metaData => `[[EXTERNO_${metaData.campo}]]` === campoExterno.restriccionFormatoMax);

                if (variable !== undefined) {

                    variableRestriccionExterna[`[[EXTERNO_${variable.campo}]]`] = {
                        "valor": genericaSistema.uts[variable.campo],
                        "ctiTexto": `${variable.ctiTexto}= ${genericaSistema.uts[variable.campo].toString()}`
                    }

                }
                else {
                    variable = metadataGenericaSistema.find(metaData => `[[EXTERNO_${metaData.campo}]]` === campoExterno.restriccionFormatoMin);

                    if (variable !== undefined) {
                        variableRestriccionExterna[`[[EXTERNO_${variable.campo}]]`] = {
                            "valor": genericaSistema.uts[variable.campo],
                            "ctiTexto": `${campoExterno.campo}= ${genericaSistema.uts[variable.campo].toString()}`
                        }
                    }
                }


            });

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                variableRestriccionExterna: variableRestriccionExterna
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
            }

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            //console.log("genericaSistema,", genericaSistema);

            /*
            setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
            setMetadataGenericaFormularioFactura(metadataTgOperacion);
            setGenericaFormularioFactura(datoRelacionadoVacio);
            setGenericaSistemaDialogFormularioFactura(true);*/

            setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
            setMetadataGenericaFormulario(metadataTgOperacion);
            setGenericaFormulario(datoRelacionadoVacio);
            setGenericaSistemaDialogFormulario(true);

        }
        else {

        }

    }

    const verListaAsociada = async (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica)
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                    //filtroUts[`ctiTexto${itemOpsCampo.campotgRef}`] = Object.keys(genericaSistema.uts).includes(`ctiTexto${itemOpsCampo.campotg}`) ? genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] : genericaSistema.uts['ctiTexto'] || selectedTipoGenerica.ctiTexto;

                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }

                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                categoriaTg: tgRef.categoriaTgRef,
                tipoOrganizacionContenido: tgRef.tipoOrganizacionContenidotgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),

                // estos aún tiene mejora
            }

            let nameEventPadre =
                nameEventPadre = (props.codMenu + "-" + tgRef.id + "-" + newSelectedTipoGenerica.ctiTextoFiltroUts).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(" ", "_");


            console.log("genericaSistema.uts, ", genericaSistema.uts, "lista nueva, ", newSelectedTipoGenerica);

            let eventPadre = { item: { name: nameEventPadre, codMenu: props.codMenu, level: props.level + 1, selectedTipoGenerica: newSelectedTipoGenerica, label: tgRef.ctiTextotgRef } }
            props.addSubTabMenu(eventPadre);

        }

        else {

        }

    }

    const confirmdeleteGenericaSistema = (genericaSistema) => {
        setGenericaFormulario(genericaSistema);
        setDeletegenericaSistemaDialogFormulario(true);
    }

    const deleteGenericaSistema = () => {
        let _genericasSistema = genericasSistema.filter(val => val.id !== genericaFormulario.id);
        setGenericasSistema(_genericasSistema);
        setDeletegenericaSistemaDialogFormulario(false);
        setGenericaFormulario(emptyGenericaSistema);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'genericaSistema Deleted', life: 3000 });
    }

    const findIndexById = (id) => {

        let index = -1;
        for (let i = 0; i < genericasSistema.length; i++) {
            if (genericasSistema[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    /*
    const createId = () => {
        let id = '';
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }
    */

    const confirmDeleteSelected = () => {
        setdeletegenericasSistemaDialog(true);
    }

    const cols = [
        { field: 'code', header: 'Code' },
        { field: 'name', header: 'Name' },
        { field: 'category', header: 'Category' },
        { field: 'quantity', header: 'Quantity' }
    ];

    const exportColumns = selectedColumnsSegmentos.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0)
        .map((col) => ({ title: col.ctiTexto, dataKey: col.campo }));

    ///columnsDataTable

    const exportPdf = () => {
        genericasSistema.map(x => x.uts)
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                doc.autoTable(exportColumns, genericasSistema.map(x => x.uts));
                doc.save('datos.pdf');
            });
        });
    };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(genericasSistema.map(x => x.uts));
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'products');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    //<Button icon="pi pi-upload" className="p-button-rounded p-button-secondary mr-1" aria-label='Exportar' tooltip='Exportar' onClick={exportCSV} />

    const leftToolbarTemplate = () => {

        //console.log("selectedTipoGenerica.operaciones, ", selectedTipoGenerica.operaciones );

        //throw new Exception("Falta implementar pregunta");
        return (
            <div className="my-2">

                <Button type="button" icon="pi pi-file-excel" severity="success" className="p-button-rounded" onClick={exportExcel} data-pr-tooltip="XLS" />

                {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "NEW") ? <Button icon="pi pi-plus" className="p-button-rounded p-button-info mr-1" tooltip='New' onClick={openNew} /> : <></>}


                {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "REMOVE") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-1" tooltip='Delete' onClick={confirmDeleteSelected} disabled={selectedGenericasSistemaSegmento === null} /> : <></>}

                {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "EXPORT_XLS") ? <Button type="button" icon="pi pi-file-excel" severity="success" className="p-button-rounded" onClick={exportExcel} data-pr-tooltip="XLS" /> : <></>}

                {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "EXPORT_PDF") ? <Button type="button" icon="pi pi-file-pdf" severity="warning" className="p-button-rounded" onClick={exportPdf} data-pr-tooltip="PDF" /> : <></>}

                <Button icon="pi pi-filter-slash" className="p-button-rounded p-button-secondary mr-1" tooltip="clear filters" onClick={clearFilter1} />

            </div>

        )
    }

    const showOverlayPanel = (e) => {
        overlayPanelRef.current.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const rightToolbarTemplate = () => {

        return (
            <>
                <Button type="button" icon="pi pi-bars" aria-label='Columas en tabla' onClick={(e) => showOverlayPanel(e)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                <OverlayPanel ref={overlayPanelRef} showCloseIcon style={{ width: '25rem', 'margin-top': '1rem', 'margin-left': '1rem' }} className="overlaypanel-demo">
                    <MultiSelect value={selectedColumnsSegmentos} className="mr-1"
                        options={metadataGenericaSistema.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0)}
                        optionLabel="ctiTexto" onChange={onColumnToggle} style={{ width: '20em' }} />
                </OverlayPanel>
            </>


        )
    }


    const tipoOperacionesRow = ["EDIT", "EDIT_F", "REPORT", "LIST", "SEND_EMAIL"];

    const actionBodyTemplate = (rowData) => {

        return (
            <div className="actions">
                {
                    selectedTipoGenerica.operaciones.filter(x => tipoOperacionesRow.includes(x.tipoOperacion))
                        .map(x => {
                            if (x.tipoOperacion !== "SEND_EMAIL" || (x.tipoOperacion === "SEND_EMAIL" && !rowData.uts["enviado"])) {
                                return (<Button icon={x.icono} idopsgenerica={x.id} className="p-button-rounded p-button-success mr-2" tooltip={x.ctiTexto} aria-label={x.ctiTexto}
                                    onClick={(e) => {
                                        switch (x.tipoOperacion) {
                                            case "EDIT": editGenericaSistemaFormulario(e, rowData); break;
                                            case "EDIT_F": editGenericaSistemaFormularioFactura(e, rowData); break;
                                            case "REPORT": reportarEvidencia(e, rowData); break;
                                            case "LIST": verListaAsociada(e, rowData); break;
                                            case "SEND_EMAIL": sendMailGenerica(e, rowData); break;
                                        }
                                    }}
                                />)
                            }
                            else {
                                return <></>;
                            }

                        }
                        )
                }
            </div>
        );
    }

    const deletegenericaSistemaDialogFormularioFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hidedeletegenericaSistemaDialogFormulario} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteGenericaSistema} />
        </>
    );
    const deletegenericasSistemaDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hidedeletegenericasSistemaDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedgenericasSistema} />
        </>
    );

    const onSelectionChangeSegmento = (event) => {
        const value = event.value;
        setSelectedGenericasSistemaSegmento(value);

        if (props.onSelectionChange)
            props.onSelectionChange(value);
        //setSelectAll(value.length === totalRecords);

    }

    const onSelectionChangePregunta = (event) => {
        const value = event.value;
        setSelectedGenericasSistemaPregunta(value);

        if (props.onSelectionChange)
            props.onSelectionChange(value);
        //setSelectAll(value.length === totalRecords);

    }

    const crearNewEmptyGenerica = (metadata, selectedTipoGenericaRef) => {

        if (selectedTipoGenericaRef === undefined)
            selectedTipoGenericaRef = selectedTipoGenerica;

        let item = {}

        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";
        item['tg'] = metadata.length > 0 ? metadata[0].tg : "";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;

            else {

                let newVal = "";
                if (x.tipoDato === "date")
                    newVal = 0;
                else if (x.tipoDato === "int") newVal = 0;
                else if (x.tipoDato === "double") newVal = 0.0;
                else if (x.tipoDato === "money") newVal = 0;

                if (selectedTipoGenericaRef.filtroUts !== undefined && Object.keys(selectedTipoGenericaRef.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenericaRef.filtroUts[x.campo];
                    //console.log("newVal,", x.campo,newVal);
                    //console.log("selectedTipoGenerica,", selectedTipoGenerica);
                }

                //item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
                item['uts'][`${x.campo}`] = newVal
            }
        });

        return item;

    }

    useEffect(() => {

        if (selectedTipoGenerica !== undefined) {
            setSelectedGenericasSistemaSegmento(null);
            setSelectedGenericasSistemaPregunta(null);
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        setLoading(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                }
            }
        }

        genericaSistemaService.getGenericasSistema(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);

            setGenericasSistema(data.data)
            setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    /*
    const onSelectAllChange = (event) => {
        const selectAll = event.checked;

        if (selectAll) {
            genericaSistemaService.getGenericasSistema(selectedTipoGenerica.tg).then(data => {
                setSelectAll(true);
                setSelectedGenericasSistema(data.genericas);
            });
        }
        else {
            setSelectAll(false);
            setSelectedGenericasSistema([]);
        }
    }

    */

    //<InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="USD" locale="en-US" />
    const ColumnFilterTemplate = (options) => {


        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        //const metadataRef =  metadataGenericaSistemaRef.find(et => et.campo ===options.field);
        const metadata = metadataGenericaSistema.find(et => et.campo === options.field);
        const metaColumn = selectedColumnsSegmentos.find(et => et.campo === options.field);

        //const lazyParamCampo = Object.keys(lazyParams.filters).includes(options.field) ? lazyParams.filters[`${metadata.campo}`] : null;
        //const val = lazyParamCampo !== null ? lazyParamCampo.value : "";

        switch (metadata.tipoDato) {
            case "boolean": return <TriStateCheckbox id={`filter${metadata.tg + '-' + metadata.campo}`} value={options.value} onChange={(e) => { console.log("cambio boolean", e); options.filterCallback(e.value) }} />;
            case "int": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            case "double": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            case "money": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="currency" currency="COP" locale="es-CO" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            default: return (<InputText id={`filter${metadata.tg + '-' + metadata.campo}`} ref={e => metaColumn.columnRef = e} placeholder="Search..." type="search" style={{ paddingLeft: '0.5rem', minWidth: '5rem', maxWidth: '10rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} />);
        }

        //return <TriStateCheckbox id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} value={options.value} onChange={(e) => options.filterCallback(e.value)}   />

        //if (metadataRef=== undefined)
        //return (<InputText id ={`filter${options.field}`} type="search" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)
        //else
        //return (<InputText id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} type="search" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)

    }

    const onfilterapply = (options, event) => {
        options.filterApplyCallback(event.target.value);
    }

    const columnBodyTemplate = (tipoDato, formatoDato) => {

        if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && formatoDato === "ACA_UNIDAD_RA_CRITERIO_NIVEL") {
            return selectedOptionBodyTemplate;
        }


        switch (tipoDato) {
            case 'boolean':
                return booleanBodyTemplate
            case 'double':
                return doubleBodyTemplate
            case 'int':
                return intBodyTemplate
            case 'money':
                return moneyBodyTemplate
            case 'tags':
                return tagsBodyTemplate
            case 'text':
                return textRichBodyTemplate
            case 'date':
                return dateBodyTemplate
            case 'color':
                return colorBodyTemplate
            case 'file':
                return fileBodyTemplate
            default:
                return textBodyTemplate
        }
    }

    const selectedOptionBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === "ctiTexto" + column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }
        if (val === "")
            val = "Pendiente";

        return <span >{val}</span>;

    }

    const colorBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => x => rowData.tg === x.tg && x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <ColorPicker disabled value={val} />;
    }

    function isValidColor(strColor) {
        var s = new Option().style;
        s.color = strColor;

        // return 'false' if color wasn't assigned
        return s.color === strColor.toLowerCase();
    }

    const tagsBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);

        let tagsString = "";

        if (metadata) {
            tagsString = rowData.uts[column.field];
        }

        if (tagsString !== undefined && tagsString !== "") {

            let tags = JSON.parse('' + tagsString + '');

            if (tags !== null) {
                return (

                    tags.map((x,index) =>
                        <Tag key ={index} rounded style={{ backgroundColor: isValidColor(x.color) ? x.color : "#" + x.color }} value={x.ctiTexto}>
                        </Tag>

                    )

                );

            }
            else {
                return (<></>);
            }



        }
        else
            return (<></>);


    }

    const booleanBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : typeof rowData.uts[column.field] === "string" ? rowData.uts[column.field].toLowerCase() === "true" : false;
        }

        return <i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')}></i>;
        //return (<Checkbox checked={val} readOnly className='surface-300' ></Checkbox>);
    }

    const doubleBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toFixed(2)}</span>;
    }

    const intBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        if (metadata) {
            val = rowData.uts[column.field];
        }

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 100;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        return (
            <>
                {
                    (function () {
                        //rounded text raised                         
                        if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                    })()
                }

                <span style={{ maxWidth: "5rem", wordBreak: "break-word" }} >{val}</span>

            </>
        );

    }

    const textRichBodyTemplate = (rowData, column,) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }

        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: valTexto }} />
            </>
        );
    }

    const fileBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let valRefDoc = "";
        if (metadata) {
            valRefDoc = rowData.uts[column.field];
        }

        if ((valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== ""))
            return (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Archivo</Link>);
        else
            return <span>No presenta adjunto</span>
    }

    const dateBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleDateString() + " " + val.toLocaleTimeString()}</span>;
    }

    const ConvertTipoDatoADateTypeTabla = (tipoDato) => {

        let res = "text";

        switch (tipoDato) {
            case "date": res = "date"; break;
            case "int": res = "numeric"; break;
            case "double": res = "numeric"; break;
            case "money": res = "numeric"; break;
            case "boolean": res = "boolean"; break;
            default: res = "text"; break;
        }

        return res;
    }

    const cellEditor = (options) => {
        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => x.campo === options.field)
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => options.tg === x.tg && x.campo === options.field)

        if (metadata.tipoDato === 'int') return intEditor(options);
        else if (metadata.tipoDato === 'double') return doubleEditor(options);
        else if (metadata.tipoDato === 'money') return moneyEditor(options);
        if (metadata.tipoDato === 'date') return dateEditor(options);
        if (metadata.tipoDato === 'boolean') return booleanEditor(options);
        else if (metadata.tipoDato === 'NOTARA') return selectButtonEditor(options);
        else return textEditor(options);
    };

    const selectButtonEditor = (options) => {
        let items = [
            { name: 'Option 1', value: 1 }
        ];

        console.log("options, ", options);
        console.log("optionsSelectButton, ", optionsSelectButton);

        let criterioRA = options.rowData.uts['criterioRA'];

        items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts['criterioRA'] === criterioRA).map(x => ({ value: x.uts[''], 'name': x.uts['ctiTextonivelDesempenoRA'] }));

        return (
            <SelectButton value={options.value} optionLabel="name" onChange={(e) => { console.log("newValue,", e.value); if (e.value !== null) options.editorCallback(e.value) }} options={items} multiple />
        );

    };

    const dateEditor = (options) => {
        return <Calendar value={options.value || options.rowData.uts[options.field]} showButtonBar yearNavigator={false} showIcon dateFormat="dd/mm/yy" onChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const moneyEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value); }} mode="currency" currency="COP" locale="es-CO" />;
    };

    const booleanEditor = (options) => {
        console.log("options, ", options, "options.rowData.uts[options.field], ", options.rowData.uts[options.field]);
        let valBase = options.value !== undefined ? options.value : options.rowData.uts[options.field];
        let val = typeof valBase === "boolean" ? valBase : typeof valBase === "string" ? valBase.toLowerCase() === "true" : false;

        //return <InputNumber value={options.value} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value); }} mode="currency" currency="COP" locale="es-CO" />;
        return <Checkbox checked={val} onChange={(e) => { console.log("evento, ", e); if (e.checked !== null) options.editorCallback(e.checked); }}  ></Checkbox>
    };

    const intEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const doubleEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} mode="decimal" onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const textEditor = (options) => {
        return <InputText type="text" value={options.value || options.rowData.uts[options.field]} onChange={(e) => { if (e.target.value !== null) options.editorCallback(e.target.value) }} />;
    };

    /*const isPositiveInteger = (val) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };
    */

    const onCellEditComplete = async (e) => {

        let { rowData, newValue, field, originalEvent: event } = e;

        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoading(true);

        if (newValue !== undefined && rowData.uts[field] !== newValue) {

            //[field] = newValue;

            let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.tipoOperacion === "EDIT_ROW")

            let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {

                    if (itemOpsCampo.campotg === field)
                        genericaSistema.uts[itemOpsCampo.campotgRef] = newValue;
                    else
                        genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

                }
            }
            genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

            console.log("sende, ", genericaSistema);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                console.log("response, ", response);

                let genericaSistemaAffect = response.genericasSistemaAffected[0];

                if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {

                    if (response.mensaje === "") {

                        if (rowData.id > 0) {
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = genericaSistemaAffect.id;
                            rowData.cti = genericaSistemaAffect.cti;
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;

                            /*const index = findIndexById(rowData.id);
                            let _genericasSistema = [...genericasSistema]
    
                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg!=="")
                            _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
    
                            setGenericasSistema(_genericasSistema);*/

                            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                            //_genericasSistema.unshift(_genericaSistema);
                        }




                        //setGenericaSistemaDialogFormulario(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {

                        if (rowData.id > 0) {
                            rowData.uts[field] = newValue;
                            //rowData.uts  = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = response.id;
                            rowData.cti = response.cti;
                            if (response.campoSequenceTg !== "")
                                rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                            rowData.uts[field] = newValue;

                            /*const index = findIndexById(rowData.id);
                            let _genericasSistema = [...genericasSistema]
    
                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg!=="")
                            _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
    
                            setGenericasSistema(_genericasSistema);*/

                            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                            //_genericasSistema.unshift(_genericaSistema);
                        }

                    }

                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

            });

            /*
            switch (field) {
                case 'quantity':
                case 'price':
                    if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;

                default:
                    if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
            }*/

        }

        setLoading(false);

    };

    const columnsDataTableSegmentos = selectedColumnsSegmentos.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0).map(k => {

        if (k.actualizableEnTabla) {

            return <Column key={k.campo} field={k.campo} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
                //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                //header={k.ctiTexto} sortable filter filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
                editor={canEditRow ? (options) => cellEditor(options) : null} onCellEditComplete={canEditRow ? onCellEditComplete : null}
            />;

        }
        else {

            return <Column key={k.campo} field={k.campo} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
            //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
            //header={k.ctiTexto} sortable filter  filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
            />;
        }

    });

    const columnsDataTablePreguntas = selectedColumnsPreguntas.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0).map(k => {

        if (k.actualizableEnTabla) {

            return <Column key={k.campo} field={k.campo} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
                //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                //header={k.ctiTexto} sortable filter filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
                editor={canEditRow ? (options) => cellEditor(options) : null} onCellEditComplete={canEditRow ? onCellEditComplete : null}
            />;

        }
        else {

            return <Column key={k.campo} field={k.campo} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
            //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
            //header={k.ctiTexto} sortable filter  filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
            />;
        }

    });



    const clearFilter1 = () => {
        initFilters1();
    }

    const onColumnToggle = (event) => {

        let newselectedColumns = event.value;

        let orderedSelectedColumns = metadataGenericaSistema.filter(col => newselectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0));

        setSelectedColumnsSegmentos(orderedSelectedColumns);
    }


    const header2 = () => {

        if (selectedTipoGenerica !== undefined) {
            //GetTextoEtiqueta("LABEL_MANAGE") + " - " +
            return (<div className="">
                <h5 className="m-0">{selectedTipoGenerica.ctiTextoFiltroUts !== null && selectedTipoGenerica.ctiTextoFiltroUts !== undefined
                    && selectedTipoGenerica.ctiTextoFiltroUts !== "" ? selectedTipoGenerica.ctiTextoFiltroUts : selectedTipoGenerica.ctiTexto}</h5>
                <br></br>
                <Toolbar className="mb-1" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

            </div>)
        }
        else {
            return (<div className="">
                <Toolbar className="mb-1" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

            </div>)
        }
    }

    /*
        const header2 = (
            <div className="">
    
                <h5 className="m-0">{ selectedTipoGenerica.ctiTextoFiltroUts !== null && selectedTipoGenerica.ctiTextoFiltroUts !== undefined && selectedTipoGenerica.ctiTextoFiltroUts !== ""? selectedTipoGenerica.ctiTextoFiltroUts : GetTextoEtiqueta("LABEL_MANAGE") + " - " + selectedTipoGenerica.ctiTexto}</h5>
                <br></br>
                <Toolbar className="mb-1" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
    
            </div>
    
        );*/

    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "date": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                case "int": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                case "double": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                case "money": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "equals","ref": null }`; break;
            }

        });

        headers += '}';



        return (JSON.parse('' + headers + ''));
    }


    const initFilters1 = () => {
        setLazyParams(Object.assign({}, lazyParamsInitSelected));
        //setGlobalFilterValue2('');
    }

    const buscarFilter1 = () => {
        setLazyParams(Object.assign({}, lazyParams));
        //setGlobalFilterValue2('');
    }

    const arrayTemplate = [{}, {}, {}, {}, {}, {}];
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }


    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

        console.log("sssss, ", idOriginal, genericasSistemaAffect);
        setSubmitted(true);

        let _genericasSistema = [...genericasSistema];

        genericasSistemaAffect.forEach(genericaSistemaAffect => {

            //if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {
            if (1 == 0) {
                if (idOriginal > 0) {

                    const index = findIndexById(genericaFormulario.id);

                    _genericasSistema[index].uts = genericaSistemaAffect.uts;

                    /*var newLazyParam = Object.assign({}, lazyParams);
                    newLazyParam.iteracion = newLazyParam.iteracion+1;
                    
                    setLazyParams(newLazyParam);
                    */


                }
                else {
                    //console.log("unshift, ",_genericaSistema);
                    //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                    _genericasSistema.unshift(genericaSistemaAffect || _genericaSistema);

                }

                setGenericasSistema(_genericasSistema);

            }
            else {
                /*
                if (idOriginal > 0) {
    
                    const index = findIndexById(idtgAffect);
    
                    if (valuesAffected.length > 0) {
                        for (let campo in valuesAffected) {
                            _genericasSistema[index][campo] = valuesAffected[campo];
                        }
    
                    }
    
                }
                else {
                    //console.log("unshift, ",_genericaSistema);
                    //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                    _genericasSistema.unshift(_genericaSistema);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
                }*/

                setLazyParams({ ...lazyParams });

            }

        });

        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

        setGenericaSistemaDialogFormulario(false);
        setGenericaFormulario(crearNewEmptyGenerica(metadataGenericaFormulario));

    }

    const onSaveSuccessfulFormularioFactura = (_genericaSistema, idOriginal, idtgAffect, tgAffect, valuesAffected) => {

        setSubmitted(true);


        let _genericasSistema = [...genericasSistema];
        if (idOriginal > 0) {
            const index = findIndexById(genericaFormulario.id);

            _genericasSistema[index] = _genericaSistema;

            /*var newLazyParam = Object.assign({}, lazyParams);
            newLazyParam.iteracion = newLazyParam.iteracion+1;
            
            setLazyParams(newLazyParam);
            */
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

        }
        else {
            //console.log("unshift, ",_genericaSistema);
            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
            _genericasSistema.unshift(_genericaSistema);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
        }

        setGenericasSistema(_genericasSistema);
        setGenericaSistemaDialogFormulario(false);
        setGenericaFormulario(crearNewEmptyGenerica(metadataGenericaFormulario));

    }

    const template = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-start`;
        const titleClassName = `${options.titleClassName} pl-1`;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <span className={titleClassName}>
                    Header
                </span>
            </div>
        )
    }

    const preguntasBodyTemplate = (segmento) =>



        preguntas.filter(et => et.uts['segmento'] === segmento.uts['segmento'])//(et => et.ctiConfigurado >= 0 && et.esImprimible > 0)
            .map((p,index) => {

                return (
                    <Card key ={index} className='field'  >
                        {textRichBodyTemplate(p, { field: "ctiTexto" }, metadataGenericaPregunta)}
                    </Card>
                )

            })
        ;

    const segmentosBodyTemplate = segmentos//.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0)
        .map((s, index) => {

            return (
                <Panel key ={index} className='mt-3 p-1' header={textRichBodyTemplate(s, { field: "ctiTexto" }, metadataGenericaSegmento)} toggleable>
                    {textRichBodyTemplate(s, { field: "ctiTextoDesc" }, metadataGenericaSegmento)}
                    <div className='p-2' >
                        {preguntasBodyTemplate(s)}
                    </div>
                </Panel>
            )

        });

    const onRowExpandPregunta = (event) => {
        toast.current.show({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    };

    const onRowCollapsePregunta = (event) => {
        toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    };

    const expandAllPregunta = () => {
        let _expandedRows = {};

        //genericasSistema.forEach((p) => (_expandedRows[`${p.id}`] = true));
        preguntas.forEach((p) => (_expandedRows[`${p.id}`] = true));

        setExpandedRowsPregunta(_expandedRows);
    };

    const collapseAllPregunta = () => {
        setExpandedRowsPregunta(null);
    };

    const allowExpansionPregunta = (rowData) => {
        //return rowData.orders.length > 0;
        return true;
    };

    //<h5>Orders for {data.uts["ctiTexto"]}</h5>
    const rowExpansionTemplatePregunta = (data) => {
        return (
            <div className="p-3">


                {columnBodyTemplate(data.uts["tipoDato"], data.uts["formatoDato"])}

            </div>
        );
    };


    const onRowExpandSegmento = (event) => {
        toast.current.show({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    };

    const onRowCollapseSegmento = (event) => {
        toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    };

    const expandAllSegmento = () => {
        let _expandedRows = {};

        //genericasSistema.forEach((p) => (_expandedRows[`${p.id}`] = true));
        segmentos.forEach((p) => (_expandedRows[`${p.indexRow}`] = true));

        setExpandedRowsSegmento(_expandedRows);
    };

    const collapseAllSegmento = () => {
        setExpandedRowsSegmento(null);
    };

    const allowExpansionSegmento = (rowData) => {
        //return rowData.orders.length > 0;
        return true;
    };

    //<h5>Orders for {data.uts["ctiTexto"]}</h5>

    const preguntaTemplate = () => {
        //return rowData.orders.length > 0;

        if ("1" === "1") {

        return <Column key={"ctiTexto"} field={"ctiTexto"}
        body={previewBodyTemplate}/>;
        }
        /*
        else {
            return <Column key={k.campo} field={k.campo} //dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
                //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                //header={k.ctiTexto} sortable filter filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
                editor={canEditRow ? (options) => cellEditor(options) : null} onCellEditComplete={canEditRow ? onCellEditComplete : null}
            />;

        }
        */


        //key={k.campo} field={k.campo} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
        //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
        //header={k.ctiTexto} sortable filter  filterElement={ColumnFilterTemplate} filterPlaceholder="Buscar por xyz"
        
    };

    const templatePreview = (rowData) => {
        return (<><span>{rowData.uts["ctiTexto"]}</span> <span>({rowData.uts["tipoDato"]})</span> </>);
    }

    const previewBodyTemplate = (rowData) => {

        return (<>
            <div style={{ maxWidth: "5rem", wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: rowData.uts["ctiTexto"] }} />

            {
                (function () {
                    switch (rowData.uts.tipoDato) {
                        case 'boolean':
                            return booleanPreviewBodyTemplate(rowData);
                        case 'int':
                            return intPreviewBodyTemplate(rowData);
                        case 'double':
                            return doublePreviewBodyTemplate(rowData);
                        case 'money':
                            return moneyPreviewBodyTemplate(rowData);
                        case 'tags':
                            return tagsPreviewBodyTemplate(rowData);
                        case 'text':
                            return textRichPreviewBodyTemplate(rowData);
                        case 'date':
                            return datePreviewBodyTemplate(rowData);
                        case 'color':
                            return colorPreviewBodyTemplate(rowData);
                        case 'file':
                            return filePreviewBodyTemplate(rowData);
                        default:
                            return textPreviewBodyTemplate(rowData);
                    }
                })()

            }
        </>);

    }

    const selectedOptionPreviewBodyTemplate = (rowData, column) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === "ctiTexto" + column.field);
        let val = "";
        /*if (metadata) {
            val = rowData.uts[column.field];
        }
        if (val === "")
            val = "Pendiente";
*/
        return <span >{val}</span>;

    }

    const colorPreviewBodyTemplate = (rowData, column) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => x => rowData.tg === x.tg && x.campo === column.field);
        let val = "";

        /*
        if (metadata) {
            val = rowData.uts[column.field];
        }*/

        return <ColorPicker disabled value={"blue"} />;
    }

    function isValidColor(strColor) {
        var s = new Option().style;
        s.color = strColor;

        // return 'false' if color wasn't assigned
        return s.color === strColor.toLowerCase();
    }

    const tagsPreviewBodyTemplate = (rowData, column) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);

        let tagsString = "[{color:blue, ctiTexto='Demo'}]";

        /*
        if (metadata) {
            tagsString = rowData.uts[column.field];
        }*/

        if (tagsString !== undefined && tagsString !== "") {

            let tags = JSON.parse('' + tagsString + '');

            if (tags !== null) {
                return (

                    tags.map((x,index) =>
                        <Tag key={index} rounded style={{ backgroundColor: isValidColor(x.color) ? x.color : "#" + x.color }} value={x.ctiTexto}>
                        </Tag>

                    )

                );

            }
            else {
                return (<></>);
            }



        }
        else
            return (<></>);


    }

    const booleanPreviewBodyTemplate = (rowData, column) => {
        /*let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : typeof rowData.uts[column.field] === "string" ? rowData.uts[column.field].toLowerCase() === "true" : false;
        }*/

        return <i className={classNames('pi', true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')}></i>;
        //return (<Checkbox checked={val} readOnly className='surface-300' ></Checkbox>);
    }

    const doublePreviewBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = 1000;
        /*if (metadata) {
            val = rowData.uts[column.field];
        }*/

        return <span >{val.toFixed(2)}</span>;
    }

    const intPreviewBodyTemplate = (rowData, column) => {
        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = 1000;
        /*if (metadata) {
            val = rowData.uts[column.field];
        }*/

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyPreviewBodyTemplate = (rowData, column) => {
        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = 1000;
        /*if (metadata) {
            val = rowData.uts[column.field];
        }*/

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textPreviewBodyTemplate = (rowData, column) => {

        console.log("textPreviewBodyTemplate,", rowData);

        /*
        let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        if (metadata) {
            val = rowData.uts[column.field];
        }d

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 100;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;
        
        */
        let valTexto = "Texto de prueba";
        let tamMaximoVisibleFila = 100;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;


        return (
            <>
                {
                    (function () {
                        //rounded text raised                         
                        if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                    })()
                }

                <span style={{ maxWidth: "5rem", wordBreak: "break-word" }} >{val}</span>

            </>
        );

    }

    const textRichPreviewBodyTemplate = (rowData, column,) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);

        let valTexto = "Texto de prueba";
        /*if (metadata) {
            valTexto = rowData.uts[column.field];
        }*/

        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: valTexto }} />
            </>
        );
    }

    const filePreviewBodyTemplate = (rowData, column) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let valRefDoc = "";

        /*if (metadata) {
            valRefDoc = rowData.uts[column.field];
        }*/

        if ((valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== ""))
            return (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Archivo</Link>);
        else
            return <span>No presenta adjunto</span>
    }

    const datePreviewBodyTemplate = (rowData, column) => {

        //let metadata = metadataGenericaSistemaTgOperaciones.find(x => rowData.tg === x.tg && x.campo === column.field);
        let val = Date.now();
        /*if (metadata) {
            val = rowData.uts[column.field];
        }*/

        return <span >{val.toLocaleDateString() + " " + val.toLocaleTimeString()}</span>;
    }


    const rowExpansionTemplateSegmento = (data) => {

        //console.log("rowExpansionTemplateSegmento, ", preguntas);
        return (
            <div className="p-3">


                <DataTable lazy value={preguntas.filter(x => x.uts["segmento"] === data.uts["segmento"])} dataKey="indexRow" //ref={dt}
                    header={headerPregunta()}
                    //filterDisplay="row" 
                    style={{ width: '100%', height: '100%' }}
                    //paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 100, 250, 10000]}
                    //onPage={onPage} size="small"
                    //onFilter={onFilter} filters={lazyParams.filters} 
                    loading={loading}
                    //onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    selection={selectedGenericasSistemaPregunta} onSelectionChange={onSelectionChangePregunta}
                    resizableColumns //tableStyle={{ minWidth: '60rem' }}
                    expandedRows={expandedRowsPregunta} onRowToggle={(e) => setExpandedRowsPregunta(e.data)}
                    onRowExpand={onRowExpandPregunta} onRowCollapse={onRowCollapsePregunta} rowExpansionTemplate={rowExpansionTemplatePregunta}
                    //selectAll={selectAll} 
                    //onSelectAllChange={onSelectAllChange}
                    //globalFilter={globalFilter} 
                    reorderableRows onRowReorder={(e) => setPreguntas(e.value)}
                    emptyMessage={GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}
                    className="datatable-responsive"
                    responsiveLayout="scroll" selectionMode="single"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    reorderableColumns={true} currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column rowReorder style={{ width: '3rem' }} />
                    <Column expander={allowExpansionPregunta} style={{ width: '2rem' }} />
                    <Column key="actionBody" body={actionBodyTemplate} style={{ width: '2rem' }} ></Column>
                    {preguntaTemplate()}

                </DataTable>

            </div>
        );
        //{columnsDataTablePreguntas}
    };

    const header = (
        <div className="flex flex-wrap justify-content-end gap-2">
            <Button icon="pi pi-plus" label="Expand All" onClick={expandAllSegmento} text />
            <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAllSegmento} text />
        </div>
    );

    const headerPregunta = () => {
        return (
            <div className="my-2">


                {selectedTipoGenericaPregunta.operaciones.some(x => x.tipoOperacion === "NEW") ? <Button icon="pi pi-plus" className="p-button-rounded p-button-info mr-1" tooltip='New' onClick={openNewPregunta} /> : <></>}

                {selectedTipoGenericaPregunta.operaciones.some(x => x.tipoOperacion === "REMOVE") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-1" tooltip='Delete' onClick={confirmDeleteSelected} disabled={true} /> : <></>}

            </div>);
    }

    //console.log("preguntas, ",preguntas, "selectedTipoGenerica, ",selectedTipoGenerica, "metadataGenericaSistema, ",metadataGenericaSistema,"genericaFormulario, ",genericaFormulario);

    if (selectedTipoGenerica === undefined || !selectedTipoGenerica.tg || !selectedTipoGenerica.tg === "" ||
        selectedTipoGenerica.operaciones === undefined || metadataGenericaSistema.length === 0 || genericaFormulario === undefined || optionsSelectButton === undefined) { //|| selectedTipoGenericaFormulario === undefined) {

        return (<DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
        </DataTable>)
    }

    else if (selectedTipoGenerica.operaciones === undefined) {

        return (<span>No se encuentran permisos asociados</span>)
    }

    else {
        //if(props.selectedTipoGenerica.tg ==="BAS_MACROPROCESO" )
        //  console.log("DataTableGenerica props", props.selectedTipoGenerica=== selectedTipoGenerica ,props.selectedTipoGenerica, "selectedTipoGenerica, ", selectedTipoGenerica);

        return (
            <>
                <Toast ref={toast} />

                <DataTable lazy value={segmentos} dataKey="indexRow" ref={dtSegmento}
                    header={header}
                    //filterDisplay="row" 
                    style={{ width: '100%', height: '100%' }}
                    //paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 100, 250, 10000]}
                    //onPage={onPage} size="small"
                    //onFilter={onFilter} filters={lazyParams.filters} 
                    loading={loading}
                    //onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    selection={selectedGenericasSistemaSegmento} onSelectionChange={onSelectionChangeSegmento}
                    resizableColumns //tableStyle={{ minWidth: '60rem' }}
                    expandedRows={expandedRowsSegmento} onRowToggle={(e) => setExpandedRowsSegmento(e.data)}
                    onRowExpand={onRowExpandSegmento} onRowCollapse={onRowCollapseSegmento} rowExpansionTemplate={rowExpansionTemplateSegmento}
                    //selectAll={selectAll} 
                    //onSelectAllChange={onSelectAllChange}
                    //globalFilter={globalFilter} 
                    reorderableRows onRowReorder={(e) => setSegmentos(e.value)}
                    emptyMessage={GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}
                    className="datatable-responsive"
                    responsiveLayout="scroll" selectionMode="single"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    reorderableColumns={true} currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column rowReorder style={{ width: '3rem' }} />
                    <Column expander={allowExpansionSegmento} style={{ width: '5rem' }} />

                    <Column key="actionBody" body={actionBodyTemplate} ></Column>
                    {columnsDataTableSegmentos}

                </DataTable>

                <Formulario ref={formRefPregunta} genericaSistemaDialog={genericaSistemaDialogFormularioPregunta} genericaSistema={genericaFormularioPregunta}
                    metadataGenericaSistemaForm={metadataGenericaFormularioPregunta}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioPregunta}
                    onHideForm={hideDialogPregunta} onSaveSuccessful={onSaveSuccessfulFormulario}></Formulario>

                <FormularioCalificacionRA ref={formFacturaRefPregunta} genericaSistemaDialog={genericaSistemaDialogFormularioFacturaPregunta} genericaSistema={genericaFormularioFacturaPregunta}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFacturaPregunta}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFacturaPregunta}
                    onHideForm={hideDialogPregunta} onSaveSuccessful={onSaveSuccessfulFormularioFactura}></FormularioCalificacionRA>

            </>
        );

    }

});

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(DataTableGenerica, comparisonFn);*/
export default DiseñadorFormulario;

